import React from 'react';
import { motion } from 'framer-motion';

const About: React.FC = () => {
  return (
    <section id="about" className="section bg-gray-50 dark:bg-gray-900">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Imagen */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1577415124269-fc1140a69e91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80"
                alt="Equipo de LuxuryEstates"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-secondary rounded-lg hidden md:block"></div>
          </motion.div>

          {/* Contenido */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark dark:text-light mb-6">
              Quiénes Somos
            </h2>
            <div className="w-24 h-1 bg-secondary mb-6"></div>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              En LuxuryEstates, nos dedicamos a conectar personas con propiedades excepcionales que reflejan su estilo de vida y aspiraciones. Con más de 15 años de experiencia en el mercado inmobiliario de lujo, hemos construido una reputación basada en la excelencia, la integridad y el servicio personalizado.
            </p>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Nuestro equipo de asesores inmobiliarios altamente cualificados combina un profundo conocimiento del mercado con una comprensión única de las necesidades de nuestros clientes, garantizando que cada transacción sea fluida y satisfactoria.
            </p>
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div>
                <h4 className="text-2xl font-bold text-primary dark:text-secondary mb-2">150+</h4>
                <p className="text-gray-600 dark:text-gray-300">Propiedades exclusivas</p>
              </div>
              <div>
                <h4 className="text-2xl font-bold text-primary dark:text-secondary mb-2">98%</h4>
                <p className="text-gray-600 dark:text-gray-300">Clientes satisfechos</p>
              </div>
              <div>
                <h4 className="text-2xl font-bold text-primary dark:text-secondary mb-2">15+</h4>
                <p className="text-gray-600 dark:text-gray-300">Años de experiencia</p>
              </div>
              <div>
                <h4 className="text-2xl font-bold text-primary dark:text-secondary mb-2">24/7</h4>
                <p className="text-gray-600 dark:text-gray-300">Atención personalizada</p>
              </div>
            </div>
            <button className="btn btn-primary">Conoce a nuestro equipo</button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;